import { render, staticRenderFns } from "./CreateEatingExperience.vue?vue&type=template&id=971bcf70&scoped=true&"
import script from "./CreateEatingExperience.vue?vue&type=script&lang=js&"
export * from "./CreateEatingExperience.vue?vue&type=script&lang=js&"
import style0 from "./CreateEatingExperience.vue?vue&type=style&index=0&id=971bcf70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971bcf70",
  null
  
)

export default component.exports